import MobileNav from './site/mobile-nav';
import MainNav from './site/main-nav';
import Accordion from './site/accordion';
import BrandStencilStats from './site/brandstencil-stats';
import BrandStencilROICalculator from './site/brandstencil-roi-calculator';
import submitOnChange from './site/submit-on-change';

import '@slightlyoff/lite-vimeo';
import '@justinribeiro/lite-youtube';

require('./framework.js');
require('./window-width.js');

/*
 * Framework
 *
 * Init
 * ------
 * Initialise all functionality
 *
 * Init can be immediate, on DOM load, or on window load
 */
(function () {
  'use strict';

  // inits
  immediateInit();
  // There's a chance the DOM content has finished loading already
  if (document.readyState !== 'loading') {
    domInit();
  } else {
    document.addEventListener('DOMContentLoaded', domInit);
  }

  window.addEventListener('load', pageInit);

  /*
   * Run immediately
   */
  function immediateInit() {
    // set up global window width listener
    // (for global responsive media query testing)
    Framework.windowWidth = new Framework.WindowWidth();
    Framework.windowWidth.init();
  }

  /*
   * Run on DOM load
   */
  function domInit() {
    /*
     * ESSENTIAL FUNCTIONALITY
     *
     * The bare necessities
     */

    // Lazy-load images
    const lozad = require('lozad');
    Framework.lozadObserver = lozad('.js-lazy-load');
    Framework.lozadObserver.observe();

    // SVG external content support
    const svg4everybody = require('svg4everybody');
    svg4everybody();

    // Make non-responsive embeds responsive
    const reframe = require('reframe.js/dist/reframe.js');
    reframe('.js-reframe iframe');

    /*
     * OPTIONAL FUNCTIONALITY
     *
     * Comment / Uncomment lines to enable functionality
     * Libraries must also be required in index.js
     *
     * If you're not using it, don't include it
     */

    Framework.mobileNav = new MobileNav();
    Framework.mainNav = new MainNav();
    Framework.accordion = new Accordion();
    Framework.brandStencilStats = new BrandStencilStats();
    Framework.brandStencilROICalculator = new BrandStencilROICalculator();

    submitOnChange();

    // Cookie consent
    // require('cookieconsent');
    // window.cookieconsent.initialise({
    //   palette: {
    //     popup: {
    //       background: '#ffffff',
    //       text: '#3a3a3a',
    //     },
    //     button: {
    //       background: '#1565c0',
    //       text: '#ffffff',
    //     },
    //   },
    //   theme: 'edgeless',
    //   content: {
    //     dismiss: 'Dismiss',
    //     link: 'Learn more',
    //   },
    // });
  }

  /*
   * Run on page (window) load
   */
  function pageInit() {}
})();
